var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20.58,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 11C21.5 16.3762 16.8309 20.7904 11 20.7904C5.16908 20.7904 0.5 16.3762 0.5 11C0.5 5.62388 5.16908 1.20972 11 1.20972C16.8309 1.20972 21.5 5.62388 21.5 11Z",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.515 15.7097V6.28972H10.8C11.875 6.28972 12.6875 6.54722 13.2375 7.06222C13.7925 7.57222 14.07 8.24472 14.07 9.07972C14.07 9.90472 13.7925 10.5747 13.2375 11.0897C12.6875 11.5997 11.875 11.8547 10.8 11.8547H8.685V15.7097H7.515ZM12.795 15.7097L10.095 11.4347H11.37L14.31 15.7097H12.795ZM8.685 11.0297H10.71C11.415 11.0297 11.95 10.8572 12.315 10.5122C12.685 10.1622 12.87 9.70972 12.87 9.15472C12.87 8.58472 12.6925 8.13222 12.3375 7.79722C11.9875 7.46222 11.475 7.29472 10.8 7.29472H8.685V11.0297Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRBlack);
export default __webpack_public_path__ + "static/media/R_Black.b4741ba7df85ddccd1571f0f6006c317.svg";
export { ForwardRef as ReactComponent };